<template>
    <!--checkboxgroup -->
    <div class="checkboxgroup-section">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "checkboxGroup",
        model: {
            prop: 'checked',
            event: 'change'
        },
        props: {
            checked: {
                type: Array,
                required: true,
            },
            max: {
                type: Number,
                default: -1
            }
        },
        watch: {
            checked: {
                handler(newVal) {
                    // console.log('newVal:', newVal, newVal.length, this.options.length)
                    this.init()
                },
                immediate: true,
                deep: true,
            }
        },
        computed: {
            length(){
                let currentValue = this.options.reduce((currentArr, cell) => {
                    cell.checked && currentArr.push(cell.name);
                    return currentArr;
                }, [])
                return currentValue.length
            }
        },
        data() {
            return {
                options: [], // 选项
            }
        },
        created() {
            this.$on('on-checkbox-add', (checkbox) => {
                this.options.push(checkbox)
                this.init()
            })
            this.$on('on-checkbox-remove', (checkbox) => {
                this.options.splice(this.options.indexOf(checkbox), 1)
                this.syncValue()
            })
            this.$on('on-checkbox-select', (checkbox)=> {
                if(this.max !== -1 && !checkbox.checked && (this.length + 1) > this.max) {
                    this.$toast.fail(`最多选择${this.max}个`)
                    return
                }
                checkbox.checked = !checkbox.checked
                this.syncValue()
            })
        },
        methods: {
            init() {
                this.options.forEach(cell => {
                    cell.checked = this.checked.find(d => d == cell.value)
                    // console.log('cell.checked:',this.checked.length, cell.checked, cell.value, typeof cell.value)
                })
            },
            syncValue() {
                let currentValue = this.options.reduce((currentArr, cell) => {
                    cell.checked && currentArr.push(cell.value);
                    return currentArr;
                }, [])
                this.$emit('change', currentValue)
            }
        }
    }
</script>

<style scoped lang="scss">
    .checkboxgroup-section {
    }
</style>


// WEBPACK FOOTER //
// src/components/checkbox/checkboxGroup.vue